import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

:root {
  --main-bg-color: #fff;
  // --main-bg-color-sec: #8a808a;
  --main-bg-color-sec: #ececec;
  --main-accent-color: #f00;
  --text-color: rgb(51, 51, 51);
}

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html{
    @media (max-width: 1700px){
        font-size: 75%;
    }
    
    @media (max-width: 300px){
        font-size: 60%;
    }
    
    scroll-behavior: smooth;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--main-bg-color-sec);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--main-bg-color);
}

body{
    background: var(--main-bg-color);
    // font-family: "Trebuchet MS", Verdana, sans-serif;
    font-family: Arial;
    overflow-x: hidden;
}

button {
    outline: none;
    font-weight: bold;
    font-size: 1.1.rem;
    cursor: pointer;
    padding: 1rem 2rem;
    border: 3px solid var(--main-accent-color);
    background: transparent;
    color: black;
    transition: all 0.5s ease;
    font-family: 'Inter', sans-serif;
    &:hover{
        background-color: var(--main-accent-color);
        color: black;
    }
}
    h2{
        font-weight: lighter;
        font-size: 4rem;
    }
    h3{
        color: black;
    }
    h4{
        font-weight: bold;
        font-size: 2rem;
       
    }
    a{
        font-size: 1.1rem;
    }
    span{
        font-weight: bold;
        color: var(--main-accent-color);
    }
    p{
        padding: 3rem 0rem;
        color: var(--text-color);
        font-size: 1.4rem;
        line-height: 150%;
    }
`;

export default GlobalStyle;
